module.exports = __webpack_public_path__ + "static/media/maint-report.cca6b56f.png";